<template>
  <div id="app" class="flex h-100 flex-wrap pagebg" style="overflow: hidden">
    <!-- 加载动画 -->
    <div class="loads" v-show="isload">
      <dv-loading style="width: 250px; height: 250px">Loading...</dv-loading>
    </div>
    <div class="time">{{ now }} {{ week }}<br/>
      <span>更新时间：{{ updateTimeText }}</span>
    </div>
    <div @click="signOut" class="power">
      <i style="cursor: pointer" class="el-icon-back"></i>
    </div>
    <div class="logoImg">
      <img style="height: 0.8rem" :src="logoSrc" />
    </div>
    <header class="w-100 h-10 flex j-center a-center">
      <dv-decoration-5
        :dur="10"
        style="position: absolute; bottom: 0; right: 0; height: 50%"
        class="w-100"
      />

      <div class="font-big1 font-weight">
        {{ title ? title : "EHS Gemba Walk" }}
      </div>
    </header>
    <div class="p w-50 h-45 flex">
      <!--月度问题关闭率--> 
      <ehs-issue-close-rate :beans="issueRate"></ehs-issue-close-rate>
    </div>
    <div class="p w-50 h-45 flex">
      <!--部门当月完成总进度 and 分别进度-->
      <ehs-dept-total :beans="jobTotal"></ehs-dept-total>
    </div>
    <div class="p w-50 h-45 flex">
      <!--部门发现率-->
      <ehs-dept-discovery-rate :beans="deptovery"></ehs-dept-discovery-rate>
    </div>
    <div class="p w-50 h-45 flex">
      <!--问题未关闭列表-->
      <ehs-issue-list :beans="issueList"></ehs-issue-list>
    </div>
  </div>
</template> 

<script>
import API from "@/utils/api";
import router from "../../../router";
import format from "date-fns/format";
export default {
  name: "App",
  data() {
    return {
      websock: null,
      reconnectData: null,
      lockReconnect: false,
      isload: false,
      issueRate: [], //问题关闭率
      jobTotal: [], //层别信息
      deptovery: [], //部门发现率,
      issueList: [], //未关闭问题列表
      now: null,
      week: null,
      logoSrc: "/assets/img/logo_light.png",
      title: "EHS GamBawalk",
      updateTimeText:null
    };
  },

  mounted() {
    this.webSocket();
    this.loadData();
    this.loadBoardTitle();
    //钟表
    setInterval(this.clock, 1000);
  },
  created() {
    this.isload = true;
  },
  destroyed() {
    if (this.websock) {
      this.lockReconnect = true;
      this.websock.close();
    }
  },
  methods: {
    signOut() {
      router.back();
    },
    loadBoardTitle() {
      var user = localStorage.getItem("user_session");

      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
      }

      API.loadTheme().then((re) => {
        if (re.success && re["list"].length > 0) {
          this.logoSrc = re["list"][0]["icon"];
        }
      });

      var params = { query: { name: "ehs" } };
      API.loadBoardTitle(params).then((re) => {
        if (re.success && re["list"].length > 0) {
          this.title = re["list"][0]["boardName"];
        }
      });
    },

    loadData() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        this.isload = false;
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
        
        API.ehsData()
          .then((res) => {
            this.isload = false;
            if (res.success === true) {
              this.issueRate = res["issueClose"];
              this.jobTotal = res["jobTotalAudit"];
              this.deptovery = res["deptDiscovery"];
              this.issueList = res["issueList"];
              var now = new Date();
              this.updateTimeText = format(now, "MM-dd HH:mm:ss");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    webSocket() {
      var http = sessionStorage.getItem("http");
      if (http) {
        http += "/websocket/ehs/monitoring";
      } else {
        http = "https://demo.biqs.cn/websocket/ehs/monitoring";
      }

      http = http.replace("https", "wss").replace("http", "ws");

      this.websock = new WebSocket(http);
      this.websock.onopen = this.websocketonopen; //连接成功
      this.websock.onmessage = this.websocketonmessage; //广播成功
      this.websock.onerror = this.websocketonerror; //连接断开，失败
      this.websock.onclose = this.websocketclose;

      let this_ = this;
    },
    //连接成功
    websocketonopen() {
      console.log("Ehs socket连接成功");
    },

    //连接失败
    websocketonerror() {
      console.log("Ehs socket连接失败");
      this.reconnect();
    },

    //各种问题导致的 连接关闭
    websocketclose() {
      console.log("EHS socket断开连接");
      this.reconnect();
    },
    //数据接收
    websocketonmessage(data) {
      console.log("socket 数据刷新");
      //刷新
      this.loadData();
    },

    //断开重连
    reconnect() {
      if (this.lockReconnect) {
        return;
      }
      this.reconnectData && clearTimeout(this.reconnectData);
      this.reconnectData = setTimeout(() => {
        this.webSocket();
      }, 5000);
    },
    clock() {
      //全局变量d，创建Date对象
      var d = new Date();
      //格式：2018-2-5  19:19:33
      this.now = format(d, "yyyy-MM-dd HH:mm:ss");
      var week = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      )[d.getDay()];
      this.week = week;
    },
  },
};
</script>

<style>
.pagebg {
  background: url("../../../assets/img/bg2.png");
}
.p {
  padding: 0rem 0.2rem;
}

.loads {
  background: #06164a;
  z-index: 999;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0%;
  top: 0%;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}

header {
  background: url("../../../assets/img/head_bg.png");
  background-size: 100% 100%;
  position: relative;
  height: 50px;
}

/* 媒体查询  */
@media screen and (max-width: 1024px) {
  html {
    font-size: 42px !important;
  }
}

@media screen and (min-width: 1920px) {
  html {
    font-size: 80px !important;
  }
}

/* 主题色 */
.color-blue {
  color: #1fe9e8;
}
.color-gray {
  color: #cdeaf6;
}
.logoImg {
  position: absolute;
  left: 80px;
  top: 0px;
  font-size: 22px;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/pages/ehs/board/board.vue